// src/i18n/locales/de.js

export default {
  countries: {
    'AF': 'Afghanistan',
    'AL': 'Albanien',
    'DZ': 'Algerien',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antigua und Barbuda',
    'AR': 'Argentinien',
    'AM': 'Armenien',
    'AU': 'Australien',
    'AT': 'Österreich',
    'AZ': 'Aserbaidschan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesch',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgien',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BT': 'Bhutan',
    'BO': 'Bolivien',
    'BA': 'Bosnien und Herzegowina',
    'BW': 'Botswana',
    'BR': 'Brasilien',
    'BN': 'Brunei',
    'BG': 'Bulgarien',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Kap Verde',
    'KH': 'Kambodscha',
    'CM': 'Kamerun',
    'CA': 'Kanada',
    'CF': 'Zentralafrikanische Republik',
    'TD': 'Tschad',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Kolombien',
    'KM': 'Komoren',
    'CG': 'Kongo',
    'CD': 'Kongo, Demokratische Republik',
    'CR': 'Costa Rica',
    'CI': 'Elfenbeinküste',
    'HR': 'Kroatien',
    'CU': 'Kuba',
    'CY': 'Zypern',
    'CZ': 'Tschechien',
    'DK': 'Dänemark',
    'DJ': 'Dschibuti',
    'DM': 'Dominica',
    'DO': 'Dominikanische Republik',
    'EC': 'Ecuador',
    'EG': 'Ägypten',
    'SV': 'El Salvador',
    'GQ': 'Äquatorialguinea',
    'ER': 'Eritrea',
    'EE': 'Estland',
    'ET': 'Äthiopien',
    'FJ': 'Fidschi',
    'FI': 'Finnland',
    'FR': 'Frankreich',
    'GA': 'Gabun',
    'GM': 'Gambia',
    'GE': 'Georgien',
    'DE': 'Deutschland',
    'GH': 'Ghana',
    'GR': 'Griechenland',
    'GD': 'Grenada',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HN': 'Honduras',
    'HU': 'Ungarn',
    'IS': 'Island',
    'IN': 'Indien',
    'ID': 'Indonesien',
    'IR': 'Iran',
    'IQ': 'Irak',
    'IE': 'Irland',
    'IL': 'Israel',
    'IT': 'Italien',
    'JM': 'Jamaika',
    'JP': 'Japan',
    'JO': 'Jordanien',
    'KZ': 'Kasachstan',
    'KE': 'Kenia',
    'KI': 'Kiribati',
    'KP': 'Nordkorea',
    'KR': 'Südkorea',
    'KW': 'Kuwait',
    'KG': 'Kirgisistan',
    'LA': 'Laos',
    'LV': 'Lettland',
    'LB': 'Libanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libyen',
    'LI': 'Liechtenstein',
    'LT': 'Litauen',
    'LU': 'Luxemburg',
    'MG': 'Madagaskar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Malediven',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshallinseln',
    'MR': 'Mauretanien',
    'MU': 'Mauritius',
    'MX': 'Mexiko',
    'FM': 'Mikronesien',
    'MD': 'Moldawien',
    'MC': 'Monaco',
    'MN': 'Mongolei',
    'ME': 'Montenegro',
    'MA': 'Marokko',
    'MZ': 'Mosambik',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Niederlande',
    'NZ': 'Neuseeland',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'MK': 'Nordmazedonien',
    'NO': 'Norwegen',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palästina',
    'PA': 'Panama',
    'PG': 'Papua-Neuguinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippinen',
    'PL': 'Polen',
    'PT': 'Portugal',
    'QA': 'Katar',
    'RO': 'Rumänien',
    'RU': 'Russland',
    'RW': 'Ruanda',
    'KN': 'St. Kitts und Nevis',
    'LC': 'St. Lucia',
    'VC': 'St. Vincent und die Grenadinen',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'São Tomé und Príncipe',
    'SA': 'Saudi-Arabien',
    'SN': 'Senegal',
    'RS': 'Serbien',
    'SC': 'Seychellen',
    'SL': 'Sierra Leone',
    'SG': 'Singapur',
    'SK': 'Slowakei',
    'SI': 'Slowenien',
    'SB': 'Salomonen',
    'SO': 'Somalia',
    'ZA': 'Südafrika',
    'SS': 'Südsudan',
    'ES': 'Spanien',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Schweden',
    'CH': 'Schweiz',
    'SY': 'Syrien',
    'TJ': 'Tadschikistan',
    'TZ': 'Tansania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad und Tobago',
    'TN': 'Tunesien',
    'TR': 'Türkei',
    'TM': 'Turkmenistan',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'Vereinigte Arabische Emirate',
    'GB': 'Vereinigtes Königreich',
    'US': 'Vereinigte Staaten',
    'UY': 'Uruguay',
    'UZ': 'Usbekistan',
    'VU': 'Vanuatu',
    'VA': 'Vatikanstadt',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Jemen',
    'ZM': 'Sambia',
    'ZW': 'Simbabwe'
  },
  verification: {
    verifying: 'Ihre E-Mail wird überprüft...',
    success: 'E-Mail erfolgreich verifiziert!',
    failed: 'Verifizierung fehlgeschlagen',
    accountVerified: 'Ihr Konto wurde erfolgreich verifiziert. Sie können sich jetzt in Ihr Konto einloggen.',
    invalidLink: 'Der Verifizierungslink ist ungültig oder abgelaufen.',
    missingToken: 'Verifizierungstoken fehlt.',
    generalError: 'Ein Fehler ist während der Verifizierung aufgetreten. Bitte versuchen Sie es später noch einmal.',
    proceedToLogin: 'Zum Login fortfahren',
    backToLogin: 'Zurück zum Login'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dashboard',
    system: 'System',
    settings: 'Einstellungen',
    overview: 'Übersicht',
    database: 'Datenbank',
    logs: 'Protokolle',
    userManagement: 'Benutzerverwaltung',
    security: 'Sicherheit',
    systemAdministration: 'Systemadministration',
    loading: 'Laden...',
    close: 'Dashboard schließen',
    edit: 'Bearbeiten',
    systemUptime: 'Systembetriebszeit',
    avgResponseTime: 'Durchschnittliche Antwortzeit',
    errorRate: 'Fehlerquote',
    activeUsers: 'Aktive Benutzer',
    monthlyActiveUsers: 'Monatlich aktive Benutzer (MAU)',
    fromLastMonth: 'vom letzten Monat',
    today: 'Heute',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'Systemzustand',
      hierarchy: 'Wissenshierarchie', // NEW
      documents: 'Dokumentenverwaltung', // NEW
      database: 'Datenbank',
      logs: 'Protokolle',
      security: 'Sicherheit',
      users: 'Benutzer'
    },
    // --- NEW KEYS ---
    contentManagement: "INHALTSVERWALTUNG",
    knowledgeHierarchy: "Wissenshierarchie",
    documentManagement: "Dokumentenverwaltung",
    noLogsFound: "Heute keine Protokolle gefunden",
    invalidLogsResponse: "Ungültige Antwortstruktur der Protokollzusammenfassung",
    logsSummaryError: "Fehler beim Laden der Protokollzusammenfassung",
    buttons: {
      save: "Speichern",
      cancel: "Abbrechen",
      switch: "Trotzdem wechseln",
      discard: "Verwerfen"
    },
    confirm: {
      defaultTitle: "Bestätigen",
      defaultMessage: "Sind Sie sicher?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Systemzustandsstatus',
    runDiagnostics: 'Diagnose ausführen',
    resourceUsage: 'Ressourcennutzung',
    services: {
      apiServices: 'API-Dienste',
      database: 'Datenbank',
      cache: 'Cache',
      storage: 'Speicher',
      messageQueue: 'Nachrichtenwarteschlange',
      externalApi: 'Externe API'
    },
    resources: {
      cpu: 'CPU-Nutzung',
      memory: 'Speicherauslastung',
      storage: 'Speicherverbrauch',
      network: 'Netzwerkbandbreite'
    },
    databaseManagement: 'Datenbankverwaltung',
    reindexDatabase: 'Datenbank neu indizieren',
    lastReindex: 'Letzte Neuindizierung',
    databaseSize: 'Datenbankgröße',
    totalTables: 'Gesamttabellen',
    logManagement: 'Protokollverwaltung',
    rolloverLogs: 'Protokolle umschalten',
    searchLogs: 'Protokolle durchsuchen',
    logTime: 'Zeit',
    logLevel: 'Ebene',
    logService: 'Dienst',
    logMessage: 'Nachricht',
    showingEntries: 'Zeige {start}-{end} von {total} Einträgen',
    logLevels: {
      error: 'FEHLER',
      warn: 'WARNUNG',
      info: 'INFO',
      debug: 'DEBUG'
    },
    logMessages: {
      connectionTimeout: 'Verbindungszeitüberschreitung zum externen Anbieter',
      lowDiskSpace: 'Festplattenspeicher unter 10% Schwellenwert',
      userRoleUpdated: 'Benutzerrolle für admin@huduma.ai aktualisiert'
    },
    userName: 'Name',
    userEmail: 'E-Mail',
    userRole: 'Rolle',
    userStatus: 'Status',
    userActions: 'Aktionen',
    roleAdministrator: 'Administrator',
    roleUser: 'Benutzer',
    statusActive: 'Aktiv',
    dbActions: {
      reindex: 'Neu indizieren',
      backup: 'Sichern',
      optimize: 'Optimieren',
      reindexDesc: 'Datenbankindizes neu erstellen',
      backupDesc: 'Datenbanksicherung erstellen',
      optimizeDesc: 'Abfrageleistung optimieren'
    },
    operations: {
      reindexTitle: 'Ergebnisse der Datenbankneuindizierung',
      backupTitle: 'Ergebnisse der Datenbanksicherung',
      optimizeTitle: 'Ergebnisse der Datenbankoptimierung',
      reindexResults: 'Neuindizierungsergebnisse',
      optimizeResults: 'Optimierungsergebnisse',
      collection: 'Sammlung',
      status: 'Status',
      indexSuggestions: 'Indexvorschläge',
      backupDetails: 'Sicherungsdetails',
      backupFile: 'Sicherungsdatei',
      backupLocation: 'Ort',
      backupSize: 'Größe',
      errorDetails: 'Fehlerdetails',
      close: 'Schließen',
      resultsTitle: 'Operationsergebnisse',
      reindexDatabase: {
        success: 'Datenbankneuindizierung erfolgreich abgeschlossen',
        error: 'Fehler bei der Datenbankneuindizierung',
        loading: 'Datenbank wird neu indiziert...'
      },
      backupDatabase: {
        success: 'Datenbanksicherung erfolgreich abgeschlossen',
        error: 'Fehler bei der Datenbanksicherung',
        loading: 'Datenbank wird gesichert...'
      },
      optimizeDatabase: {
        success: 'Datenbankoptimierung erfolgreich abgeschlossen',
        error: 'Fehler bei der Datenbankoptimierung',
        loading: 'Datenbank wird optimiert...'
      },
      rolloverLogs: {
        success: 'Protokollumschaltung erfolgreich abgeschlossen',
        loading: 'Protokolle werden umgeschaltet...'
      },
      searchLogs: {
        success: 'Protokollsuche abgeschlossen',
        loading: 'Protokolle werden durchsucht...'
      },
      runDiagnostics: {
        success: 'Diagnose erfolgreich abgeschlossen',
        loading: 'Diagnose wird durchgeführt...'
      },
      runSecurityScan: {
        success: 'Sicherheitsscan erfolgreich abgeschlossen',
        loading: 'Sicherheitsscan wird durchgeführt...'
      },
      cancel: 'Abbrechen',
      save: 'Änderungen speichern'
    },
    userManagementSection: {
      totalUsers: 'Gesamtbenutzer',
      newUsers: 'Neue Benutzer (Monat)',
      searchUsers: 'Benutzer suchen...',
      clearSearch: 'Suche löschen',
      search: 'Suchen',
      usersFound: 'Benutzer gefunden',
      showAllUsers: 'Alle Benutzer anzeigen',
      searching: 'Suche...',
      searchingUsers: 'Suche nach Benutzern...',
      noUsersFound: 'Keine Benutzer gefunden, die den Suchkriterien entsprechen.',
      noUsers: 'Keine Benutzer verfügbar.',
      showing: 'Anzeige',
      of: 'von',
      previous: 'Vorherige',
      next: 'Nächste',
      searchFields: {
        all: 'Alle Felder',
        name: 'Name',
        email: 'E-Mail',
        role: 'Rolle'
      },
      userSearch: {
        resultsFound: '{total} Benutzer gefunden, die mit "{term}" übereinstimmen',
        error: 'Fehler bei der Benutzersuche'
      }
    },
    logsSection: {
      errorLogs: 'Fehlerprotokolle',
      warningLogs: 'Warnprotokolle',
      noErrorLogs: 'Heute keine Fehlerprotokolle aufgezeichnet.',
      noWarningLogs: 'Heute keine Warnprotokolle aufgezeichnet.',
      infoLogsNote: 'Info-Protokolle werden in der Zusammenfassung nicht angezeigt. Verwenden Sie die Suchfunktion, um alle Protokolltypen anzuzeigen.',
      searchResults: 'Neueste Suchergebnisse',
      entriesFound: 'Einträge gefunden',
      viewAllResults: 'Alle Ergebnisse anzeigen',
      logType: 'Typ',
      logCount: 'Anzahl',
      logTypes: {
        connectionTimeout: 'Verbindungszeitüberschreitung',
        databaseFailed: 'Datenbankabfrage fehlgeschlagen',
        authFailed: 'Authentifizierung fehlgeschlagen',
        lowDiskSpace: 'Festplattenspeicher unter Schwellenwert',
        slowQuery: 'Langsame Abfrageleistung',
        rateLimit: 'Ratenbegrenzung erreicht'
      },
      logSearch: {
        noResultsFound: 'Keine Protokolle entsprechen Ihren Suchkriterien',
        resultsFound: '{count} Protokolleinträge gefunden'
      }
    },
    security: {
      title: 'Sicherheitsüberwachung',
      securityScan: 'Sicherheitsscan',
      runningSecurityScan: 'Scan wird durchgeführt...',
      lastSecurityScan: 'Letzter Sicherheitsscan',
      vulnerabilitiesFound: 'Gefundene Schwachstellen',
      daysAgo: 'Tage zuvor',
      critical: 'kritisch',
      medium: 'mittel',
      low: 'niedrig',
      failedLoginAttempts: 'Fehlgeschlagene Anmeldeversuche (24h)',
      suspiciousActivities: 'Verdächtige Aktivitäten (24h)',
      securityRecommendations: 'Sicherheitsempfehlungen',
      criticalVulnerabilities: 'Kritische Schwachstellen',
      mediumVulnerabilities: 'Mittlere Schwachstellen',
      lowVulnerabilities: 'Niedrige Schwachstellen',
      authenticationIssues: 'Authentifizierungsprobleme',
      suspiciousActivityLogs: 'Protokolle verdächtiger Aktivitäten',
      securityProbeAttempts: 'Erkannte Sicherheitsprüfversuche',
      sensitiveFileAccess: 'Erkannte Versuche, auf sensible Dateien oder Endpunkte zuzugreifen',
      envFileAccess: 'Zugriffsversuche auf Umgebungsdateien',
      envFileAccessDesc: 'Erkannte Zugriffsversuche auf .env-Dateien',
      gitRepoAccess: 'Zugriffsversuche auf Git-Repository',
      gitRepoAccessDesc: 'Erkannte Zugriffsversuche auf Git-Repository-Dateien',
      recommendedAction: 'Empfohlene Maßnahme',
      rateLimitRecommendation: 'Erwägen Sie die Implementierung von Ratenbegrenzung, IP-Sperrung für wiederholte Verstöße und stellen Sie sicher, dass die Serverhärtung ordnungsgemäß implementiert ist.',
      envFileRecommendation: 'Stellen Sie sicher, dass Umgebungsdateien nicht über Webverzeichnisse zugänglich sind und Serverkonfigurationen den Zugriff auf sensible Dateien blockieren.',
      gitRepoRecommendation: 'Stellen Sie sicher, dass .git-Verzeichnisse ordnungsgemäß gesichert und nicht über das Web zugänglich sind.',
      noVulnerabilitiesFound: 'Keine Schwachstellen gefunden',
      systemSecure: 'Ihr System scheint sicher zu sein. Führen Sie regelmäßige Überwachungen fort.',
      loadingScan: 'Scan-Ergebnisse werden geladen...',
      occurrences: 'Vorkommen',
      firstSeen: 'Erstmals gesehen',
      lastSeen: 'Zuletzt gesehen',
      timestamp: 'Zeitstempel',
      message: 'Nachricht',
      service: 'Dienst',
      type: 'Typ',
      severity: 'Schweregrad',
      url: 'URL',
      matchedTerm: 'Übereinstimmender Begriff',
      lineNumber: 'Zeilennummer',
      lineNumbers: 'Zeilennummern',
      showLess: 'Weniger anzeigen',
      showMore: 'Alle Probleme anzeigen',
      // --- NEW KEY ---
      lastScanJustNow: "Gerade eben"
    },
    userEdit: {
      title: 'Benutzer bearbeiten',
      loading: 'Benutzerdaten werden geladen...',
      userInfo: 'Benutzerinformationen',
      userId: 'Benutzer-ID',
      loginName: 'Anmeldename',
      fullName: 'Vollständiger Name',
      dob: 'Geburtsdatum',
      email: 'E-Mail',
      emailVerified: 'E-Mail verifiziert',
      verified: 'Verifiziert',
      notVerified: 'Nicht verifiziert',
      createdAt: 'Erstellt',
      lastLogin: 'Letzter Login',
      never: 'Nie',
      accountSettings: 'Kontoeinstellungen',
      accountStatus: 'Kontostatus',
      accountEnabled: 'Konto aktiviert',
      cannotDisableSelf: 'Sie können Ihr eigenes Konto nicht deaktivieren',
      accountRole: 'Kontorolle',
      adminRole: 'Admin-Rolle',
      cannotChangeOwnRole: 'Sie können Ihre eigene Rolle nicht ändern',
      adminActions: 'Admin-Aktionen',
      verifyEmail: 'E-Mail verifizieren',
      resetPassword: 'Passwort zurücksetzen senden',
      forceLogout: 'Abmeldung erzwingen',
      failedToLoad: 'Fehler beim Laden der Benutzerdaten',
      errorLoading: 'Fehler beim Laden der Benutzerdaten',
      saveSuccess: 'Benutzereinstellungen erfolgreich aktualisiert',
      errorSaving: 'Fehler beim Speichern der Benutzereinstellungen',
      verifyEmailSuccess: 'Verifizierungs-E-Mail erfolgreich gesendet',
      emailVerificationFailed: 'Fehler beim Senden der Verifizierungs-E-Mail',
      errorVerifyingEmail: 'Fehler beim Senden der Verifizierungs-E-Mail',
      passwordResetSent: 'Passwort-Zurücksetzungs-E-Mail gesendet',
      passwordResetFailed: 'Fehler beim Senden des Passwort-Zurücksetzens',
      errorSendingReset: 'Fehler beim Senden des Passwort-Zurücksetzens',
      logoutForced: 'Benutzer wurde abgemeldet',
      logoutFailed: 'Fehler beim Erzwingen der Abmeldung',
      errorForcingLogout: 'Fehler beim Erzwingen der Abmeldung',
      // --- NEW KEY ---
      userUpdated: "Benutzer erfolgreich aktualisiert"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: 'Wissenshierarchie-Verwaltung (Hinweis: immer Englisch - Übersetzungen hinzufügen)',
      addCategory: 'Neue Kategorie hinzufügen',
      loading: 'Hierarchie wird geladen...',
      addService: 'Dienst hinzufügen',
      editCategory: 'Kategorie bearbeiten',
      deleteCategory: 'Kategorie löschen',
      editService: 'Dienst bearbeiten',
      deleteService: 'Dienst löschen',
      empty: 'Keine Kategorien gefunden. Klicken Sie auf "Neue Kategorie hinzufügen", um zu beginnen.',
      formTitleCreateCategory: 'Neue Kategorie erstellen',
      formTitleAddService: 'Dienst zu "{categoryName}" hinzufügen',
      formTitleEditCategory: 'Kategorie bearbeiten: "{itemName}"',
      formTitleEditService: 'Dienst bearbeiten: "{itemName}"',
      nameEnLabel: 'Name (Englisch)',
      translationsTitle: 'Übersetzungen zur Anzeige',
      loadingTranslations: 'Übersetzungen werden geladen...',
      selectLang: 'Sprache auswählen',
      translationPlaceholder: 'Übersetzung eingeben',
      deleteTranslation: 'Übersetzung löschen',
      addTranslation: '+ Übersetzung hinzufügen',
      saveSuccess: 'Hierarchieelement erfolgreich gespeichert.',
      saveError: 'Fehler beim Speichern des Hierarchieelements.',
      loadError: 'Fehler beim Laden der Wissenshierarchie.',
      loadTranslationsError: 'Fehler beim Laden der Übersetzungen.',
      confirmCancelTitle: 'Ungespeicherte Änderungen',
      confirmCancelEdit: 'Sie haben ungespeicherte Änderungen, die verloren gehen. Möchten Sie wirklich wechseln?',
      confirmDeleteTitleCategory: 'Kategorie löschen?',
      confirmDeleteTitleService: 'Dienst löschen?',
      confirmDeleteCategory: 'Sind Sie sicher, dass Sie die Kategorie "{itemName}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      confirmDeleteService: 'Sind Sie sicher, dass Sie den Dienst "{itemName}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteSuccessCategory: 'Kategorie erfolgreich gelöscht.',
      deleteSuccessService: 'Dienst erfolgreich gelöscht.',
      deleteErrorCategory: 'Fehler beim Löschen der Kategorie.',
      deleteErrorService: 'Fehler beim Löschen des Dienstes.',
      duplicateLangError: 'Doppelte Sprachen in den Übersetzungen gefunden. Bitte entfernen Sie sie.'
    },
    // --- NEW OBJECT ---
    documents: {
      title: 'Dokumentenverwaltung',
      addLink: 'Von Link hinzufügen',
      uploadFiles: 'Dateien hochladen',
      searchPlaceholder: 'Suche nach Dateinamen...',
      allStatuses: 'Alle Status',
      statusPending: 'Ausstehend',
      statusIngested: 'Aufgenommen',
      statusRetracted: 'Zurückgezogen',
      // --- NEW STATUSES ADDED ---
      statusIngesting: "In Aufnahme",
      statusError: "Aufnahmefehler",
      statusWarning: "Aufgenommen m. Warnungen",
      // ---
      ingestSelected: 'Ausgewählte aufnehmen',
      colFileName: 'Dateiname',
      colStatus: 'Status',
      colLabels: 'Etiketten',
      colUploadDate: 'Hochladedatum',
      colSize: 'Größe',
      loading: 'Dokumente werden geladen...',
      empty: 'Keine Dokumente gefunden.',
      loadError: 'Fehler beim Laden der Dokumente.',
      confirmIngestTitle: 'Batch-Aufnahme bestätigen',
      ingest: 'Aufnehmen',
      confirmIngestSelected: 'Sind Sie sicher, dass Sie {count} ausgewählte Datei(en) aufnehmen möchten?',
      ingestQueuedSuccess: '{count} Datei(en) wurden zur Aufnahme in die Warteschlange gestellt.',
      ingestQueuedError: 'Während des Batch-Aufnahmeprozesses ist ein Fehler aufgetreten.',
      uploadSuccessMultiple: '{count} Datei(en) erfolgreich hochgeladen.',
      linkSubmitSuccess: 'Erfolgreich gecrawlt und "{fileName}" gespeichert.',
      actionSuccess: 'Aktion "{action}" für Datei {fileId} war erfolgreich.',
      metadataUpdateSuccess: 'Metadaten für Datei {fileId} wurden aktualisiert.'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Neues Passwort erstellen',
    tokenLabel: 'Zurücksetzungs-Token',
    tokenPlaceholder: 'Zurücksetzungs-Token eingeben',
    validateButton: 'Token validieren',
    newPasswordLabel: 'Neues Passwort',
    newPasswordPlaceholder: 'Neues Passwort erstellen',
    confirmNewPasswordLabel: 'Neues Passwort bestätigen',
    confirmNewPasswordPlaceholder: 'Neues Passwort bestätigen',
    resetButton: 'Passwort zurücksetzen',
    processing: 'Zurücksetzen...',
    rememberedPassword: 'Passwort erinnert?',
    backToLogin: 'Zurück zum Login',
    supportMessage: 'Benötigen Sie Hilfe? Kontaktieren Sie unser Support-Team',
    passwordRequirements: 'Das Passwort muss mindestens 8 Zeichen lang sein und mindestens 1 Zahl, 1 Großbuchstaben und 1 Sonderzeichen enthalten',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    resetSuccess: 'Ihr Passwort wurde erfolgreich zurückgesetzt',
    resetFailed: 'Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut.',
    noTokenProvided: 'Bitte geben Sie einen Zurücksetzungs-Token an',
    expiredToken: 'Dieser Zurücksetzungs-Token ist abgelaufen. Bitte fordern Sie einen neuen an.',
    invalidToken: 'Ungültiger oder nicht erkannter Zurücksetzungs-Token',
    validatingToken: 'Token wird validiert...',
    redirecting: 'Weiterleitung zur Login-Seite...',
    passwordStrength: 'Passwortstärke',
    strengthLabels: {
      veryWeak: 'Sehr schwach',
      weak: 'Schwach',
      fair: 'Ausreichend',
      good: 'Gut',
      strong: 'Stark'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Verwenden Sie mindestens 8 Zeichen',
      addUppercase: 'Großbuchstaben hinzufügen',
      addLowercase: 'Kleinbuchstaben hinzufügen',
      addNumbers: 'Zahlen hinzufügen',
      addSpecialChars: 'Sonderzeichen hinzufügen'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Ihr Passwort zurücksetzen',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
    resetButton: 'Zurücksetzungslink senden',
    processing: 'Senden...',
    rememberPassword: 'Passwort erinnert?',
    backToLogin: 'Zurück zum Login',
    supportMessage: 'Benötigen Sie Hilfe? Kontaktieren Sie unser Support-Team',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    resetRequestSuccess: 'Ein Passwort-Zurücksetzungslink wurde an Ihre E-Mail gesendet',
    resetRequestFailed: 'Passwort-Zurücksetzungslink konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    checkEmail: 'Bitte überprüfen Sie Ihre E-Mail für weitere Anweisungen.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Neues Konto erstellen",
    username: "Benutzername",
    usernamePlaceholder: "Geben Sie einen Benutzernamen ein",
    email: "E-Mail",
    emailPlaceholder: "Geben Sie Ihre E-Mail ein",
    password: "Passwort",
    passwordPlaceholder: "Passwort erstellen",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Passwort bestätigen",
    acceptTerms: "Ich akzeptiere die",
    termsOfService: "Nutzungsbedingungen",
    registerButton: "Konto erstellen",
    processing: "Verarbeitung...",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    loginNow: "Jetzt einloggen",
    privacyNotice: "Durch die Registrierung stimmen Sie unseren Nutzungsbedingungen und Datenschutzrichtlinien zu",
    usernameMinLength: "Der Benutzername muss mindestens 3 Zeichen lang sein",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordRequirements: "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens 1 Zahl und 1 Großbuchstaben enthalten",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    mustAcceptTerms: "Sie müssen die Nutzungsbedingungen akzeptieren",
    registrationFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    usernameExists: "Benutzername existiert bereits",
    emailExists: "E-Mail existiert bereits",
    registrationSuccess: "Registrierung erfolgreich!",
    verificationEmailSent: "Eine Verifizierungs-E-Mail wurde an {email} gesendet",
    checkEmailInstructions: "Bitte überprüfen Sie Ihre E-Mail und folgen Sie den Anweisungen, um Ihr Konto zu verifizieren, bevor Sie sich einloggen.",
    backToLogin: "Zurück zum Login",
    noEmailReceived: "Keine E-Mail erhalten?",
    resendVerification: "Verifizierungs-E-Mail erneut senden",
    verificationResent: "Verifizierungs-E-Mail wurde erneut gesendet",
    verificationResendFailed: "Erneutes Senden der Verifizierungs-E-Mail fehlgeschlagen. Bitte versuchen Sie es erneut.",
    usernameInvalidChars: 'Der Benutzername darf nur Buchstaben, Zahlen, Unterstriche, Punkte und Bindestriche enthalten',
    networkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Benutzername',
    password: 'Passwort',
    loginButton: 'Login',
    or: 'oder',
    savedAccounts: 'Gespeicherte Konten',
    loginSuccess: 'Login erfolgreich',
    loginError: 'Login fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.',
    googleLogin: 'Mit Google fortfahren',
    facebookLogin: 'Mit Facebook fortfahren',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    noAccount: 'Kein Konto?',
    createAccount: 'Konto erstellen',
    registerNow: "Jetzt registrieren",
    termsAndPolicy: 'Durch das Einloggen stimmen Sie unseren Nutzungsbedingungen und Datenschutzrichtlinien zu',
    loggingIn: "Einloggen...",
    fieldsRequired: "Benutzername und Passwort sind erforderlich",
    invalidCredentials: "Ungültiger Benutzername oder Passwort",
    tooManyAttempts: "Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.",
    loginFailed: "Login fehlgeschlagen. Bitte versuchen Sie es erneut.",
    oauthNotImplemented: "Soziale Anmeldung ist noch nicht implementiert",
    savedLoginNotImplemented: "Gespeicherte Kontoanmeldung ist noch nicht implementiert"
  },
  charts: {
    tooltip: {
      title: 'Datum',
      totalQueries: 'Gesamtanfragen',
      uniqueUsers: 'Einzigartige Benutzer'
    },
    day: 'Tag',
    noData: 'Keine Daten',
    notAvailable: 'N/A',
    topQueries: 'Top-Anfragen',
    categoryDistribution: 'Nutzung nach Wissensbereich',
    usageTrend: 'Nutzungstrend'
  },
  analytics: {
    title: 'Datenanalyse & Einblicke',
    loading: 'Lade Analysedaten...',
    period: 'Zeitraum',
    charts: {
      satisfactionHeatmap: "Zufriedenheit nach Wissensbereich",
      satisfactionSubtitle: "Prozentuale Bewertungen im Zeitverlauf"
    },
    timePeriods: {
      week4: "Vor 4 Wochen",
      week3: "Vor 3 Wochen",
      week2: "Vor 2 Wochen",
      week1: "Letzte Woche",
      current: "Aktuell"
    },
    errors: {
      loading: "Fehler beim Laden der Zufriedenheitsdaten. Bitte versuchen Sie es erneut.",
    },
    status: {
      loading: 'Laden...',
      noData: 'Keine Daten für diesen Zeitraum verfügbar',
      error: 'Fehler beim Laden der Analysedaten',
      online: "System online",
      offline: "System offline",
      responseTime: "Durchschnittliche Antwortzeit",
      queueLength: "Warteschlange",
      uptime: "Betriebszeit"
    },
    periods: {
      daily: 'Täglich',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      allTime: 'Gesamte Zeit'
    },
    metrics: {
      totalQueries: 'Gesamtanfragen',
      uniqueUsers: 'Einzigartige Benutzer',
      avgResponseTime: 'Durchschnittliche Antwortzeit',
      satisfaction: 'Benutzerzufriedenheit'
    },
    table: {
      rank: 'Rang',
      query: 'Anfrage',
      count: 'Anzahl',
      avgTime: 'Durchschn. Zeit'
    },
    chartLabels: {
      categories: 'Bereiche',
      serviceCategories: 'Wissensbereiche',
      byUsage: 'nach Nutzung',
      category: 'Bereich'
    },
    tooltips: {
      selectPeriod: 'Zeitraum auswählen',
      selectDate: 'Datum auswählen',
      exportData: 'Daten exportieren'
    },
    gauge: {
      historical: 'Historische Trends',
      vsPrevious: 'gegenüber vorherigem Zeitraum',
      target: 'Ziel'
    },
    ratings: {
      poor: "Schlecht",
      average: "Durchschnittlich",
      good: "Gut",
      excellent: "Ausgezeichnet"
    },
    slower: 'langsamer',
    faster: 'schneller',
    percentage: 'Prozentsatz',
    note: 'Nachfolgend finden Sie Nutzungsstatistiken und Zusammenfassungen der Benutzerfeedbacks.',
    usageStats: 'Nutzungsstatistiken',
    peakUsers: 'Spitzenzeit-Benutzer',
    activeChats: 'Aktive Chats',
    usageTrend: 'Nutzungstrend',
    topQueries: 'Top-Anfragen',
    feedbackSamples: 'Benutzerfeedback-Proben',
    close: 'Schließen',
    chartComingSoon: 'Interaktive Diagrammvisualisierung folgt bald...',
    retry: 'Wiederholen',
    dailyQueries: 'Tägliche Anfragen',
    export: 'Daten exportieren',
    dateRange: 'Datumsbereich',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    rank: 'Rang',
    query: 'Anfrage',
    count: 'Anzahl',
    avgTime: 'Durchschn. Zeit',
    serviceUsage: 'Nutzung nach Wissensbereich',
    usageTrends: 'Nutzungstrends',
    week: 'Letzte Woche',
    month: 'Letzter Monat',
    quarter: 'Letztes Quartal',
    year: 'Letztes Jahr',
    uniqueUsers: 'Einzigartige Benutzer',
    satisfactionRate: 'Zufriedenheitsrate',
    satisfactionAnalysis: 'Benutzerzufriedenheitsanalyse'
  },
  brandName: 'Genie AI: Ihr digitaler Regierungsassistent',
  nav: {
    systemStatus: 'Systemstatus',
    menu: 'Menü',
    analytics: 'Analyse',
    userProfile: 'Benutzerprofil',
    settings: 'Einstellungen',
    logout: 'Ausloggen',
    profile: 'Mein Profil',
    toggleSidebar: 'Seitenleiste umschalten',
    changeLanguage: 'Sprache ändern',
    administration: "Administration",
    languages: {
      english: 'Englisch',
      french: 'Französisch',
      swahili: 'Swahili'
    }
  },
  systemStatus: {
    title: 'Dienststatus',
    services: 'Dienste',
    operational: 'Betriebsbereit',
    degraded: 'Beeinträchtigt',
    outage: 'Ausfall',
    allOperational: 'Alle Systeme',
    someIssues: 'Einige Probleme',
    majorIssues: 'Große Probleme',
    checking: 'Überprüfen...',
    nextDeadline: 'Nächster Termin',
    days: 'Tage',
    viewDetails: 'Details anzeigen'
  },
  services: {
    eCitizen: 'eCitizen-Portal',
    taxFiling: 'Steuererklärungssystem',
    idApplication: 'ID-Antrag',
    businessReg: 'Geschäftsregistrierung',
    drivingLicense: 'Führerschein'
  },
  deadlines: {
    taxFiling: 'Frist für Steuererklärung',
    businessRenewal: 'Erneuerung der Gewerbelizenz',
    idRenewal: 'Erneuerung des Personalausweises',
    vehicleRegistration: 'Frist für Fahrzeugregistrierung'
  },
  sidebar: {
    governmentServices: 'Wissensbereiche',
    chatHistory: 'Chatverlauf',
    searchPlaceholder: 'Wissensbereiche durchsuchen...',
    createFolder: 'Ordner erstellen',
    editFolder: 'Ordner bearbeiten',
    folderName: 'Ordnername',
    folderNamePlaceholder: 'Ordnername eingeben',
    moveChat: 'Chat verschieben',
    moveChatTo: 'Chat verschieben nach',
    selectFolder: 'Ordner auswählen',
    deleteChat: 'Chat löschen',
    deleteChatConfirm: 'Sind Sie sicher, dass Sie diesen Chat löschen möchten?',
    deleteChatWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    renameChat: "Chat umbenennen",
    chatTitle: "Chat-Titel",
    chatTitlePlaceholder: "Geben Sie einen Titel für diesen Chat ein",
    deleteFolder: "Ordner löschen",
    deleteFolderConfirm: "Sind Sie sicher, dass Sie den Ordner '{name}' löschen möchten?",
    chatsMoveWarning: "Alle Chats in diesem Ordner werden in den Standardordner verschoben.",
    weatherTitle: "Wettervorhersage",
    weatherLoading: "Wetterdaten werden geladen...",
    weatherError: "Wetterdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    weatherLocationLoading: 'Standort wird geladen...',
    weatherErrorDefault: 'Wetterdaten können nicht abgerufen werden.',
    weatherGeolocationUnsupported: 'Geolokalisierung wird von Ihrem Browser nicht unterstützt.',
    weatherRefresh: 'Wetter aktualisieren',
    weatherConditions: {
      clear: 'Klar',
      partlycloudy: 'Teilweise bewölkt',
      cloudy: 'Bewölkt',
      overcast: 'Bedeckt',
      rain: 'Regen',
      shower: 'Schauer',
      thunderstorm: 'Gewitter',
      snow: 'Schnee'
    },
    folders: "Ordner",
    emptyFolder: "Dieser Ordner ist leer. Verschieben Sie Gespräche aus dem Chat-Menü hierher.",
    title: 'Info & Ressourcen',
    noChats: 'Keine aktuellen Chats',
    relatedDocs: 'Zugehörige Dokumente',
    noDocuments: 'Keine zugehörigen Dokumente',
    faq: 'Häufig gestellte Fragen',
    tab: {
      all: 'Alle Chats',
      folders: 'Ordner',
      starred: 'Markiert',
      archived: 'Archiviert'
    },
    savedChats: 'Gespeicherte Chats',
    chats: "Chats",
    allChats: "Alle Chats",
    noFolder: "Kein Ordner",
    starredChats: "Markierte Chats",
    archivedChats: "Archivierte Chats",
    noStarredChats: "Noch keine markierten Gespräche. Markieren Sie ein Gespräch, um es hier hinzuzufügen.",
    noArchivedChats: "Noch keine archivierten Gespräche.",
    noSearchResults: 'Keine Gespräche für "{term}" gefunden',
    loadingChats: "Gespräche werden geladen...",
    errorLoadingConversations: "Fehler beim Laden der Gespräche. Bitte versuchen Sie es erneut.",
    errorLoadingUser: "Benutzerdaten sind unvollständig. Bitte laden Sie die Seite neu.",
    errorNoUser: "Benutzerdaten fehlen. Bitte laden Sie die Seite neu.",
    retry: "Wiederholen",
    message: "Nachricht",
    messages: "Nachrichten",
    created: "Erstellt",
    updated: "Aktualisiert",
    star: "Markieren",
    unstar: "Markierung aufheben",
    archive: "Archivieren",
    chatStarred: "Gespräch wurde markiert",
    chatUnstarred: "Gespräch wurde entmarkiert",
    chatArchived: "Gespräch wurde archiviert",
    chatUnarchived: "Gespräch wurde aus dem Archiv entfernt",
    errorUpdatingChat: "Fehler beim Aktualisieren des Gesprächs",
    chatRenamed: "Gespräch erfolgreich umbenannt",
    errorRenamingChat: "Fehler beim Umbenennen des Gesprächs",
    chatDeleted: "Gespräch erfolgreich gelöscht",
    errorDeletingChat: "Fehler beim Löschen des Gesprächs",
    chatMoved: "Gespräch erfolgreich verschoben",
    errorMovingChat: "Fehler beim Verschieben des Gesprächs",
    noPreview: "Keine Vorschau verfügbar",
    searchConversations: 'Gespräche suchen...',
    selectFolderInstruction: "Wählen Sie einen Ordner, um dessen Gespräche anzuzeigen",
    folderCreated: "Ordner erfolgreich erstellt",
    errorCreatingFolder: "Fehler beim Erstellen des Ordners",
    errorLoadingFolders: "Fehler beim Laden der Ordner",
    folderUpdated: "Ordner erfolgreich aktualisiert",
    errorUpdatingFolder: "Fehler beim Aktualisieren des Ordners",
    folderDeleted: "Ordner erfolgreich gelöscht",
    errorDeletingFolder: "Fehler beim Löschen des Ordners",
    chatRemovedFromFolders: "Gespräch aus dem Ordner entfernt",
    errorRemovingChat: "Fehler beim Entfernen des Gesprächs aus dem Ordner",
    id: "ID",
    labels: "Etiketten",
    confidence: "Konfidenz",
    unknown: "Unbekannt"
  },
  leftPanel: {
    cat1: {
      name: '1. Identität & Zivilregistrierung',
      children: ['Geburtsurkunden', 'Personalausweise', 'Reisepässe', 'Heirats- und Sterbeurkunden', 'Wählerregistrierung']
    },
    cat2: {
      name: '2. Gesundheitswesen & Sozialdienste',
      children: ['Zugang zu öffentlichem Gesundheitswesen', 'Impfprogramme', 'Krankenversicherung', 'Behinderungsleistungen', 'Wohlfahrt und Lebensmittelhilfe']
    },
    cat3: {
      name: '3. Bildung & Lernen',
      children: ['Öffentliche Schulen und Universitäten', 'Stipendien und Studienkredite', 'Erwachsenenbildungsprogramme', 'Online-Lernressourcen']
    },
    cat4: {
      name: '4. Beschäftigung & Arbeitsdienste',
      children: ['Arbeitssuche und Arbeitslosenunterstützung', 'Arbeitnehmerschutz und Arbeitsrechte', 'Arbeitssicherheitsvorschriften', 'Fähigkeitstraining und Ausbildungen']
    },
    cat5: {
      name: '5. Steuern & Einnahmen',
      children: ['Einkommenssteuererklärung und Rückerstattungen', 'Grundsteuerzahlungen', 'Gewerbesteuerkonformität', 'Zoll und Einfuhrzölle']
    },
    cat6: {
      name: '6. Öffentliche Sicherheit & Justiz',
      children: ['Polizei und Notfalldienste', 'Gerichte und Rechtsbeistand', 'Verbrechensmeldung', 'Verbraucherschutzgesetze']
    },
    cat7: {
      name: '7. Verkehr & Mobilität',
      children: ["Führerscheine und Fahrzeugregistrierung", 'Öffentlicher Verkehr und Infrastruktur', 'Verkehrsverstöße und Bußgelder', 'Verkehrssicherheitsprogramme']
    },
    cat8: {
      name: '8. Wohnen & Stadtentwicklung',
      children: ['Öffentliche Wohnungsunterstützung', 'Immobilienregistrierung und Grundbuch', 'Wohnungsdarlehen und Subventionen', 'Zonierung und Baugenehmigungen']
    },
    cat9: {
      name: '9. Versorgungsunternehmen & Umwelt',
      children: ['Wasser- und Stromversorgung', 'Abfallmanagement und Recycling', 'Umweltvorschriften', 'Initiativen für erneuerbare Energien']
    },
    cat10: {
      name: '10. Wirtschaft & Handel',
      children: ['Geschäftsregistrierung und -lizenzierung', 'Handelsvorschriften und -genehmigungen', 'Zuschüsse und Anreize für kleine Unternehmen', 'E-Commerce und digitale Unternehmensunterstützung']
    },
    cat11: {
      name: '11. Sozialversicherung & Renten',
      children: ['Rentenleistungen', 'Pensionsfondsmanagement', 'Hinterbliebenenleistungen', 'Behinderungspensionen']
    },
    cat12: {
      name: '12. Gemeinschaft & bürgerschaftliches Engagement',
      children: ['Wahlen und Abstimmungen', 'Öffentliches Feedback und Bürgerbeschwerden', 'Freiwilligen- und Gemeinschaftsprogramme', 'Teilnahme an der lokalen Regierung']
    }
  },
  settings: {
    title: 'Einstellungen',
    save: 'Speichern',
    close: 'Schließen',
    saveSettings: 'Einstellungen speichern',
    savingSettings: "Ihre Einstellungen werden gespeichert...",
    settingsSaved: "Einstellungen erfolgreich gespeichert!",
    saveSuccess: 'Einstellungen erfolgreich gespeichert',
    saveError: 'Fehler beim Speichern der Einstellungen',
    display: 'Anzeige',
    displayLanguage: 'Anzeigesprache',
    languages: {
      english: 'Englisch',
      french: 'Französisch',
      swahili: 'Swahili'
    },
    theme: 'Thema',
    themes: {
      light: 'Hell',
      dark: 'Dunkel',
      system: 'System'
    },
    fontSize: 'Schriftgröße',
    notifications: 'Benachrichtigungen',
    emailUpdates: 'E-Mail-Updates',
    soundNotifications: 'Tonbenachrichtigungen',
    accountManagement: 'Kontenverwaltung',
    emailAddress: 'E-Mail-Adresse',
    emailAddressPlaceholder: 'Ihre E-Mail-Adresse',
    password: 'Passwort',
    changePassword: 'Passwort ändern',
    resetUserData: 'Benutzerdaten zurücksetzen',
    resetUserDataDesc: 'Dies löscht alle Ihre Profildaten und den Chatverlauf.',
    deleteAccount: 'Konto löschen',
    deleteAccountDesc: 'Dies löscht Ihr Konto und alle zugehörigen Daten dauerhaft.',
    edit: 'Bearbeiten',
    standardAccount: 'Standardkonto',
    confirmEmailChange: 'E-Mail-Änderung bestätigen',
    pleaseEnterPassword: 'Bitte geben Sie Ihr Passwort ein',
    cancel: 'Abbrechen',
    account: {
      title: 'Konto',
      resetDescription: 'Dies löscht alle Ihre Profildaten und den Chatverlauf.',
      confirmReset: 'Sind Sie sicher, dass Sie alle Ihre Daten zurücksetzen möchten? Dies kann nicht rückgängig gemacht werden.',
      resetComplete: 'Ihre Daten wurden zurückgesetzt.'
    },
    language: {
      title: 'Sprache',
      selectLabel: 'Anzeigesprache'
    },
    appearance: {
      title: 'Aussehen',
      lightTheme: 'Hell',
      darkTheme: 'Dunkel',
      systemTheme: 'System'
    },
    confirmDeleteAccount: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    confirmAccountDeletion: 'Kontolöschung bestätigen',
    accountDeletionWarning: 'Warnung: Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Alle Ihre Daten werden dauerhaft gelöscht.',
    deletionReason: 'Grund für die Löschung (optional):',
    deletionReasonPlaceholder: 'Was hat Sie dazu veranlasst, Ihr Konto zu löschen?',
    enterPasswordConfirm: 'Geben Sie Ihr Passwort zur Bestätigung ein:',
    currentPasswordPlaceholder: 'Ihr aktuelles Passwort',
    deleting: 'Löschen...',
    permanentlyDeleteAccount: 'Konto löschen',
    accountDeletedSuccess: 'Ihr Konto wurde erfolgreich gelöscht.',
    incorrectPassword: 'Falsches Passwort',
    accountDeletionFailed: 'Fehler beim Löschen des Kontos. Bitte versuchen Sie es später erneut.',
    confirmChange: 'Änderung bestätigen',
    processing: 'Verarbeitung...',
    userDataReset: 'Ihre Profildaten wurden erfolgreich zurückgesetzt.',
    failedToResetUserData: 'Fehler beim Zurücksetzen Ihrer Profildaten. Bitte versuchen Sie es später erneut.',
    changingEmailTo: 'Änderung Ihrer E-Mail zu',
    will: 'wird',
    logOutSystem: 'Sie aus dem System ausloggen',
    sendVerificationLink: 'Einen Verifizierungslink an Ihre neue E-Mail senden',
    requireVerification: 'Verifizierung erforderlich, bevor Sie sich erneut einloggen können',
    checkNewEmailVerification: 'Bitte überprüfen Sie Ihre neue E-Mail für Verifizierungsanweisungen.',
    unableToVerifyEmail: 'E-Mail konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.',
    emailAlreadyInUse: 'E-Mail wird bereits verwendet',
    enterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    failedToUpdateEmail: 'Fehler beim Aktualisieren der E-Mail. Bitte versuchen Sie es erneut.',
    passwordResetInitiated: 'Ein Passwort-Zurücksetzungslink wurde an Ihre E-Mail-Adresse gesendet.',
    unableToLoadUser: 'Benutzerinformationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    retry: 'Wiederholen',
    user: 'Benutzer',
    loadingUserInfo: 'Benutzerinformationen werden geladen...',
    resetUserDataTitle: "Benutzerdaten zurücksetzen",
    confirmResetUserData: "Sind Sie sicher, dass Sie alle Ihre Profildaten zurücksetzen möchten? Dies löscht alle Ihre Profilinformationen und den Chatverlauf, behält aber Ihre Kontodaten bei.",
    reset: "Zurücksetzen",
    deleteAccountTitle: "Konto löschen"
  },
  userProfile: {
    title: 'Benutzerprofil',
    privacyInfo: "Durch die Bereitstellung weiterer Informationen erhalten Sie präzisere und aussagekräftigere Antworten vom Chatbot. Bitte lesen Sie unsere",
    privacyPolicyLink: 'Datenschutzrichtlinie',
    tabComingSoon: 'Dieser Tab befindet sich in der Entwicklung und wird bald verfügbar sein.',
    saveSuccess: 'Profil erfolgreich gespeichert',
    loadError: 'Fehler beim Laden der Profildaten',
    saveError: 'Fehler beim Speichern des Profils',
    confirmSaveTitle: "Profil speichern",
    confirmSave: "Sind Sie sicher, dass Sie diese Änderungen speichern möchten?",
    confirmCancel: 'Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie abbrechen möchten?',
    confirmLeave: 'Sind Sie sicher, dass Sie gehen möchten? Alle ungespeicherten Änderungen gehen verloren.',
    confirmDiscardChanges: 'Ungespeicherte Änderungen verwerfen?',
    uploadPhoto: 'Foto hochladen',
    uploadFile: 'Datei hochladen',
    photoRequirements: 'Das Foto muss klar, aktuell und Ihr gesamtes Gesicht zeigen',
    biometricRequirements: 'Es werden nur offizielle biometrische Datendateien akzeptiert',
    documentUpload: 'Dokument hochladen',
    validationTitle: 'Bitte korrigieren Sie die folgenden Fehler:',
    profileIcon: 'Profil-Icon',
    change: 'Ändern',
    chooseProfileIcon: 'Profil-Icon auswählen',
    presetIcons: 'Voreingestellte Icons',
    upload: 'Hochladen',
    initials: 'Initialen',
    clickToUpload: 'Klicken zum Hochladen',
    useThisImage: 'Dieses Bild verwenden',
    useInitials: 'Initialen verwenden',
    tabs: {
      tab1: 'Persönliche Identifikationsdaten',
      tab2: 'Zivilregistrierung & Dokumentation',
      tab3: 'Adresse & Wohnsitzinformationen',
      tab4: 'Identitäts- & Reisedokumente',
      tab5: 'Gesundheits- & Krankenakten',
      tab6: 'Beschäftigungs- & Wirtschaftsdaten',
      tab7: 'Bildungs- & akademische Akten',
      tab8: 'Finanz- & Steuerdaten',
      tab9: 'Sozialversicherung & Wohlfahrt',
      tab10: 'Straf- & Rechtsakten',
      tab11: 'Verkehr & Mobilität',
      tab12: 'Bürger- & politische Beteiligung'
    },
    actions: {
      cancel: 'Abbrechen',
      save: 'Profil speichern',
      previous: 'Vorherige',
      next: 'Nächste',
      saving: 'Speichern...'
    },
    fields: {
      fullName: 'Vollständiger Name (einschließlich Aliase)',
      dob: 'Geburtsdatum',
      gender: 'Geschlecht',
      nationality: 'Nationalität',
      maritalStatus: 'Familienstand',
      photograph: 'Fotografie',
      biometric: 'Fingerabdrücke / biometrische Daten',
      birthCert: 'Geburtsurkunde',
      deathCert: 'Sterbeurkunde',
      marriageDivorce: 'Heirats- / Scheidungsunterlagen',
      adoption: 'Adoptionsunterlagen',
      citizenship: 'Staatsbürgerschafts- / Einbürgerungsdokumente',
      immigration: 'Einwanderungs- & Visumsgeschichte',
      currentAddress: 'Aktuelle Wohnadresse',
      previousAddresses: 'Vorherige Adressen',
      postalCode: 'Postleitzahl',
      country: 'Land',
      residencyStatus: 'Wohnsitzstatus',
      homeOrRental: 'Hausbesitz oder Mietdetails',
      utilityBills: 'Versorgungsrechnungen, die mit der Adresse verknüpft sind',
      landRecords: 'Grund- und Eigentumsunterlagen',
      idCard: 'Personalausweisnummer',
      passport: 'Reisepassdetails',
      driversLicense: "Führerschein",
      voterId: 'Wähler-ID',
      ssn: 'Sozialversicherungs- / Nationalversicherungsnummer',
      militaryRecords: 'Militärdienstunterlagen',
      medicalHistory: 'Medizinische Geschichte und Gesundheitszustände',
      vaccinations: 'Impfunterlagen',
      insuranceDetails: 'Krankenversicherungsdetails',
      disability: 'Behinderungsstatus',
      bloodType: 'Blutgruppe',
      organDonor: 'Organspenderstatus',
      prescriptions: 'Verschreibungen und erhaltene Behandlungen',
      mentalHealth: 'Psychische Gesundheitsgeschichte',
      eHistory: 'Beschäftigungsgeschichte',
      currentEmployer: 'Details zum aktuellen Arbeitgeber',
      workPermits: 'Arbeitserlaubnisse und Arbeitsverträge',
      certifications: 'Berufliche Zertifizierungen und Lizenzen',
      unemployment: 'Arbeitslosenstatus und erhaltene Leistungen',
      tin: 'Steuerpflichtigen-Identifikationsnummer (TIN)',
      businessAffiliations: 'Geschäftseigentum und Unternehmenszugehörigkeiten',
      schools: 'Besuchte Schulen und Universitäten',
      education: 'Bildung',
      degrees: 'Diplome, Abschlüsse und Zertifizierungen',
      performance: 'Akademische Leistungen und Testergebnisse',
      academicRecords: "Akademische Aufzeichnungen",
      scholarships: 'Erhaltene Stipendien und finanzielle Unterstützung',
      incomeTax: 'Einkommenssteuerunterlagen',
      bankAccounts: 'Bank- und Finanzkonten',
      propertyTax: 'Grundsteuerzahlungen',
      businessTax: 'Gewerbesteuererklärungen',
      pensionContrib: 'Rentenbeiträge und -entnahmen',
      loanAid: 'Darlehen und staatliche Unterstützungsunterlagen',
      pensionStatus: 'Rentenstatus und Beiträge',
      childcare: 'Kinderbetreuungsunterstützung',
      foodAssistance: 'Lebensmittelhilfe / Wohlfahrtsprogramme',
      housingAssistance: 'Wohnungsunterstützung',
      policeRecords: 'Polizeiakten (Strafgeschichte, Verhaftungen, Anklagen)',
      courtCases: 'Gerichtsfälle',
      finesPenalties: 'Bußgelder und Strafen',
      paroleProbation: 'Bewährungs- oder Probezeitstatus',
      citizenshipRevocation: 'Staatsbürgerschaftsentzug (falls zutreffend)',
      vehicleReg: 'Fahrzeugregistrierungsdetails',
      trafficViolations: 'Verkehrsverstöße und Bußgelder',
      licenseHistory: 'Führerscheingeschichte und -vermerke',
      publicTransportCard: 'Nutzung der ÖPNV-Karte',
      voterRegistration: 'Wählerregistrierungsdetails',
      electionHistory: 'Wahlbeteiligungsgeschichte',
      partyMembership: 'Parteimitgliedschaft',
      militaryStatus: 'Militärdienst- oder Wehrpflichtstatus',
      publicServiceRoles: 'Öffentliche Dienstrollen'
    },
    placeholders: {
      fullName: 'Geben Sie Ihren vollständigen gesetzlichen Namen ein',
      nationality: 'Geben Sie Ihre Nationalität ein',
      searchCountries: 'Länder suchen...',
      selectCountry: 'Land auswählen',
      searchDisciplines: "Disziplinen suchen...",
      selectDiscipline: "Disziplin auswählen",
      searchDegrees: "Abschlüsse suchen...",
      selectDegree: "Abschluss auswählen"
    },
    validation: {
      nameRequired: 'Vollständiger Name ist erforderlich',
      dobRequired: 'Geburtsdatum ist erforderlich',
      dobFuture: 'Geburtsdatum darf nicht in der Zukunft liegen',
      requiredField: '{field} ist erforderlich',
      invalidFormat: 'Ungültiges Format für {field}',
      futureDate: 'Datum darf nicht in der Zukunft liegen',
      invalidSelection: 'Bitte treffen Sie eine gültige Auswahl',
      passwordLength: 'Das Passwort muss mindestens 8 Zeichen lang sein',
      matchError: 'Felder stimmen nicht überein'
    },
    errors: {
      savingFailed: 'Fehler beim Speichern des Profils',
      loadingFailed: 'Fehler beim Laden der Profildaten',
      invalidForm: 'Bitte füllen Sie alle erforderlichen Felder aus',
      invalidFileType: 'Ungültiger Dateityp',
      fileTooLarge: 'Datei ist zu groß',
      countryLoadError: 'Fehler beim Laden der Länder',
      countryUpdateError: 'Fehler beim Aktualisieren des Landes'
    },
    notifications: {
      saveSuccess: 'Profil erfolgreich gespeichert',
      saveFailed: 'Fehler beim Speichern des Profils',
      loadSuccess: 'Profil erfolgreich geladen',
      loadFailed: 'Fehler beim Laden des Profils',
      fieldRequired: 'Dieses Feld ist erforderlich',
      uploadSuccess: 'Datei erfolgreich hochgeladen',
      uploadFailed: 'Fehler beim Hochladen der Datei',
      formChanged: 'Sie haben ungespeicherte Änderungen',
      sessionExpired: 'Ihre Sitzung ist abgelaufen, bitte loggen Sie sich erneut ein',
      profileUpdated: 'Ihr Profil wurde aktualisiert',
      profileIncomplete: 'Ihr Profil ist unvollständig'
    },
    instructions: {
      fullNameHelp: 'Geben Sie Ihren vollständigen gesetzlichen Namen ein, wie er auf Ihren offiziellen Dokumenten erscheint',
      dobHelp: 'Geben Sie Ihr Geburtsdatum im Format MM/TT/JJJJ ein',
      uploadPhotoHelp: 'Laden Sie ein aktuelles Foto hoch. Die Datei muss im JPG-, PNG- oder GIF-Format und kleiner als 2MB sein',
      passwordHelp: 'Das Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
      documentHelp: 'Akzeptierte Formate: PDF, JPG, PNG (max. 5MB)',
      requiredFields: 'Mit * markierte Felder sind erforderlich',
      selectFromList: 'Bitte wählen Sie eine Option aus der Liste',
      nextTab: 'Weiter zur nächsten Sektion',
      previousTab: 'Zurück zur vorherigen Sektion',
      saveInstructions: 'Klicken Sie auf Speichern, um Ihre Informationen zu speichern',
      cancelInstructions: 'Klicken Sie auf Abbrechen, um Änderungen zu verwerfen'
    },
    completionStatus: {
      notStarted: 'Nicht begonnen',
      inProgress: 'In Bearbeitung',
      complete: 'Abgeschlossen',
      percentComplete: '{percent}% abgeschlossen',
      tabsCompleted: '{completed} von {total} Sektionen abgeschlossen',
      tabComplete: 'Sektion abgeschlossen!'
    },
    gender: {
      male: 'Männlich',
      female: 'Weiblich',
      other: 'Andere',
      preferNot: 'Möchte nicht angeben'
    },
    maritalStatus: {
      single: 'Ledig',
      married: 'Verheiratet',
      divorced: 'Geschieden',
      widowed: 'Verwitwet',
      other: 'Andere'
    },
    residencyStatuses: {
      citizen: 'Bürger',
      permanentResident: 'Dauerhafter Einwohner',
      temporaryResident: 'Vorübergehender Einwohner',
      other: 'Andere'
    },
    employmentStatuses: {
      employed: 'Angestellt',
      selfEmployed: 'Selbstständig',
      unemployed: 'Arbeitslos',
      student: 'Student',
      retired: 'Rentner',
      homemaker: 'Hausfrau/Hausmann',
      other: 'Andere'
    },
    educationLevels: {
      primary: 'Grundschulbildung',
      secondary: 'Sekundarschulbildung',
      highSchool: 'Gymnasium',
      vocational: 'Berufsausbildung',
      associate: 'Associate-Abschluss',
      bachelor: 'Bachelor-Abschluss',
      master: 'Master-Abschluss',
      doctoral: 'Doktorgrad',
      professional: 'Berufsabschluss',
      other: 'Andere'
    },
    proficiencyLevels: {
      native: 'Muttersprachler',
      fluent: 'Fließend',
      advanced: 'Fortgeschritten',
      intermediate: 'Mittel',
      basic: 'Grundlegend'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Unbekannt'
    },
    languages: {
      english: 'Englisch',
      french: 'Französisch',
      swahili: 'Swahili',
      arabic: 'Arabisch',
      spanish: 'Spanisch',
      portuguese: 'Portugiesisch',
      chinese: 'Chinesisch',
      japanese: 'Japanisch',
      german: 'Deutsch',
      russian: 'Russisch',
      hindi: 'Hindi',
      urdu: 'Urdu',
      other: 'Andere'
    },
    yesNo: {
      yes: 'Ja',
      no: 'Nein'
    },
    select: 'Bitte auswählen',
    existingFile: 'Vorhandene Datei',
    noMatchingCountries: 'Keine übereinstimmenden Länder gefunden',
    noMatchingDisciplines: "Keine übereinstimmenden Disziplinen gefunden",
    noMatchingDegrees: "Keine übereinstimmenden Abschlüsse gefunden",
    educationOptions: [
      "Buchhaltung", "Luft- und Raumfahrttechnik", "Agrarwissenschaft", "Anthropologie", "Architektur",
      "Kunstgeschichte", "Künstliche Intelligenz", "Astronomie", "Astrophysik", "Biochemie",
      "Biomedizinische Technik", "Biotechnologie", "Betriebswirtschaft", "Chemietechnik",
      "Chemie", "Bauingenieurwesen", "Kommunikation", "Informatik", "Computerwissenschaft",
      "Baumanagement", "Strafjustiz", "Cybersicherheit", "Datenwissenschaft", "Zahnmedizin",
      "Wirtschaft", "Bildung", "Elektrotechnik", "Grundschulbildung", "Englische Literatur",
      "Umwelttechnik", "Umweltwissenschaft", "Modedesign", "Filmwissenschaft",
      "Finanzen", "Bildende Kunst", "Lebensmittelwissenschaft", "Forensische Wissenschaft", "Spieldesign",
      "Geografie", "Geologie", "Grafikdesign", "Gesundheitsmanagement", "Geschichte",
      "Hotelmanagement", "Personalwesen", "Industriedesign", "Industrietechnik", "Informationssysteme",
      "Informationstechnologie", "Innenarchitektur", "Internationales Business", "Internationale Beziehungen",
      "Journalismus", "Recht", "Bibliothekswissenschaft", "Linguistik", "Management", "Marketing",
      "Materialwissenschaft", "Mathematik", "Maschinenbau", "Medienwissenschaft", "Medizin",
      "Meteorologie", "Mikrobiologie", "Musik", "Nanotechnologie", "Pflege", "Ernährung",
      "Arbeitstherapie", "Ozeanografie", "Petroleumtechnik", "Pharmazie", "Philosophie",
      "Fotografie", "Sportpädagogik", "Physiotherapie", "Physik", "Politikwissenschaft",
      "Psychologie", "Öffentliche Verwaltung", "Öffentliche Gesundheit", "Öffentlichkeitsarbeit", "Robotik",
      "Sekundarschulbildung", "Soziale Arbeit", "Soziologie", "Softwaretechnik", "Sonderpädagogik",
      "Sportmanagement", "Statistik", "Systemtechnik", "Theaterkunst", "Tourismus",
      "Stadtplanung", "Veterinärmedizin", "Webentwicklung", "Wildtierbiologie", "Zoologie"
    ],
    degreeOptions: [
      "Associate-Abschluss", "Bachelor of Arts (BA)", "Bachelor of Science (BS)", "Bachelor of Engineering (BEng)",
      "Bachelor of Business Administration (BBA)", "Bachelor of Fine Arts (BFA)", "Bachelor of Education (BEd)",
      "Bachelor of Medicine (MBBS)", "Bachelor of Laws (LLB)", "Master of Arts (MA)", "Master of Science (MS)",
      "Master of Business Administration (MBA)", "Master of Engineering (MEng)", "Master of Fine Arts (MFA)",
      "Master of Education (MEd)", "Master of Laws (LLM)", "Master of Public Health (MPH)",
      "Doctor of Philosophy (PhD)", "Doctor of Medicine (MD)", "Doctor of Education (EdD)",
      "Doctor of Business Administration (DBA)", "Doctor of Jurisprudence (JD)", "Berufliches Diplom",
      "Technisches Diplom", "Berufszertifikat", "Postgraduiertenzertifikat", "Postgraduiertes Diplom", "Post-Doktor"
    ],
    aria: {
      tabList: 'Profilformularabschnitte',
      nextButton: 'Zur nächsten Sektion gehen',
      prevButton: 'Zur vorherigen Sektion zurückkehren',
      closeButton: 'Profilformular schließen',
      saveButton: 'Profildaten speichern',
      requiredField: 'Erforderliches Feld',
      dropdownSelect: 'Option auswählen'
    }
  },
  chatbot: {
    placeholder: 'Geben Sie Ihre Anfrage hier ein...',
    sendButton: 'Senden',
    fileReceived: 'Datei erfolgreich empfangen.',
    fileUploadError: 'Fehler beim Hochladen der Datei.',
    processingError: 'Fehler beim Verarbeiten Ihrer Anfrage.',
    timeoutError: 'Der Server braucht länger als gewöhnlich. Bitte versuchen Sie es in einem Moment erneut.',
    welcomeMessage: 'Welcome to UPB! How can I assist you with university services today?',
    attachFile: 'Datei anhängen',
    fileTooLarge: 'Datei ist zu groß. Maximale Größe ist {maxSize}.',
    saveChat: 'Chat speichern',
    chatSaved: 'Chat gespeichert',
    chatTitle: 'Chat-Titel',
    chatTitlePlaceholder: 'Geben Sie einen Titel für diesen Chat ein',
    selectFolder: 'Ordner auswählen',
    newChat: 'Neuer Chat',
    clearContext: 'Kontext löschen und neues Gespräch starten',
    unsavedChanges: 'Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie einen neuen Chat starten möchten?',
    whatCanIHelp: "Wie kann ich Ihnen heute helfen?",
    justChat: "Nur chatten",
    queryContext: "Anfragekontext",
    contextAdded: 'Kontext zu Ihrer Anfrage hinzugefügt',
    contextRemoved: 'Kontext aus Ihrer Anfrage entfernt',
    sessionUpdated: 'Sitzung aktualisiert',
    newChatStarted: 'Neues Gespräch gestartet',
    loadError: 'Chatverlauf konnte nicht geladen werden',
    responsePrefix: "Ich habe Ihre Nachricht erhalten",
    withContext: "mit Kontext",
    conversationLoaded: "Gespräch erfolgreich geladen!",
    saveConfirmTitle: "Bestehendes Gespräch speichern",
    saveConfirmMessage: "Bestehendes Gespräch speichern?",
    loadConfirmTitle: "Bestehendes Gespräch laden",
    loadConfirmMessage: "Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen und das ausgewählte Gespräch laden oder das aktuelle Gespräch zuerst speichern?",
    loadAndDiscard: "Laden und Verwerfen",
    saveAndLoad: "Speichern und Laden",
    saveAndStartNew: "Speichern und Neu starten",
    discardAndStartNew: "Verwerfen und Neu starten",
    newChatTitle: "Neuen Chat starten",
    exportChat: 'Chat exportieren',
    exportFilename: 'Dateiname',
    exportFilenamePlaceholder: 'Dateiname eingeben',
    exportButton: 'Exportieren',
    exportSuccess: 'Chat erfolgreich exportiert',
    exportError: 'Fehler beim Exportieren des Chats. Bitte versuchen Sie es erneut.'
  },
  quickhelp: {
    applyForID: "Personalausweis beantragen",
    payTaxes: "Steuern zahlen",
    startBusiness: "Ein Unternehmen gründen",
    findHealthcare: "Gesundheitsversorgung finden",
    educationServices: "Bildungsdienste",
    transportLicenses: "Verkehr & Lizenzen",
    housingPrograms: "Wohnungsprogramme",
    findJobs: "Arbeitsplätze finden",
    justChat: "Nur chatten",
    justChatPrompt: "Ich möchte über Regierungsdienste chatten",
    applyForIDPrompt: "Ich brauche Informationen, wie ich einen Personalausweis beantragen kann",
    payTaxesPrompt: "Wie ist der Prozess, um meine Steuern online zu zahlen?",
    startBusinessPrompt: "Führen Sie mich durch die Schritte zur Registrierung eines neuen Unternehmens",
    findHealthcarePrompt: "Wo finde ich Informationen über öffentliche Gesundheitsdienste?",
    educationServicesPrompt: "What academic services are available for students at UPB?",
    transportLicensesPrompt: "Wie erneuere ich meinen Führerschein?",
    housingProgramsPrompt: "Tell me about student housing options and residence halls at UPB",
    findJobsPrompt: "Welche staatlichen Arbeitsmöglichkeiten gibt es derzeit?"
  },
  common: {
    cancel: 'Abbrechen',
    create: 'Erstellen',
    save: 'Speichern',
    move: 'Verschieben',
    delete: 'Löschen',
    // --- NEW KEYS ADDED ---
    ok: 'OK',
    ingest: 'Aufnehmen',
    retract: 'Zurückziehen',
    loading: 'Laden...',
    refresh: 'Aktualisieren'
  },
  feedback: {
    title: 'Feedback',
    button: 'Feedback',
    positive: 'Positives Feedback',
    negative: 'Negatives Feedback',
    promptText: 'War diese Antwort hilfreich?',
    placeholder: 'Zusätzliche Kommentare...',
    submit: 'Feedback senden',
    close: 'Abbrechen',
    thankYouMessage: 'Vielen Dank für Ihr Feedback!',
    submitting: 'Senden...',
    error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    success: 'Vielen Dank für Ihr Feedback!',
  },
  responseRating: {
    title: 'Helfen Sie uns zu verbessern',
    note: 'Ihr Feedback wird verwendet, um den Chatbot besser abzustimmen und die Antworten im Laufe der Zeit zu verbessern.',
    chatbotResponse: 'Chatbot-Antwort:',
    ratingLabels: {
      1: 'Nutzenlos',
      2: 'Leicht hilfreich',
      3: 'Mäßig hilfreich',
      4: 'Sehr hilfreich',
      5: 'Lebensverändernd'
    },
    additionalComments: 'Zusätzliche Kommentare...',
    submit: 'Senden',
    cancel: 'Abbrechen'
  },
  // --- NEW OBJECTS ---
  upload: {
    alt: 'Hochladen'
  },
  details: {
    loading: 'Dateidetails werden geladen...',
    title: 'Dateidetails',
    close: 'Schließen',
    fileName: 'Dateiname',
    author: 'Autor',
    labels: 'Etiketten',
    selectAll: 'Alle auswählen',
    loadingLabels: 'Etiketten werden geladen...',
    status: 'Status',
    fileId: 'Datei-ID',
    fileType: 'Dateityp',
    viewFile: 'Datei anzeigen',
    visitLink: 'Externen Link besuchen',
    openFile: 'Datei in neuem Tab öffnen',
    fileSize: 'Dateigröße',
    uploadDate: 'Hochladedatum',
    hash: 'SHA256-Hash',
    // --- NEW: TABS ---
    tabs: {
      details: "Details",
      ingestionLog: "Aufnahmeprotokoll"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Abbruch-Aktionen:",
      killDocument: "Dieses Dokument abbrechen",
      killProcess: "Aufnahmeprozess abbrechen",
      timestamp: "Zeitstempel",
      level: "Ebene",
      stage: "Phase",
      message: "Nachricht",
      loadingLogs: "Protokolle werden geladen...",
      noLogs: "Keine Protokolle gefunden."
    },
    buttons: {
      saveMetadata: 'Metadaten speichern',
      retract: 'Zurückziehen',
      ingest: 'Aufnehmen'
    },
    notifications: {
      loadError: 'Fehler beim Laden der Dateidetails.',
      validationError: 'Dateiname und Autor sind erforderlich.',
      saveSuccess: 'Metadaten erfolgreich aktualisiert.',
      saveError: 'Fehler beim Speichern der Metadaten.',
      tokenError: 'Authentifizierungstoken in Benutzerdaten nicht gefunden.',
      viewError: 'Datei konnte nicht zur Ansicht geladen werden.',
      ingestSuccess: 'Datei wurde erfolgreich zur Aufnahme in die Warteschlange gestellt.',
      ingestError: 'Fehler beim Starten des Aufnahmeprozesses.',
      retractSuccess: 'Datei wurde erfolgreich zurückgezogen.',
      retractError: 'Fehler beim Zurückziehen der Datei.',
      deleteSuccess: 'Datei erfolgreich gelöscht.',
      deleteError: 'Fehler beim Löschen der Datei.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Bitte wählen Sie mindestens ein Etikett vor der Aufnahme aus.",
      ingestSaving: "Speichere Metadaten vor der Aufnahme...",
      ingestSaveFailed: "Metadaten konnten nicht gespeichert werden. Aufnahme abgebrochen.",
      logError: "Fehler beim Abrufen der Aufnahmeprotokolle.",
      killDocSent: "Abbruchanforderung für dieses Dokument wurde gesendet.",
      killProcSent: "Abbruchanforderung für den Aufnahmeprozess wurde gesendet."
    },
    confirm: {
      ingest: 'Möchten Sie diese Datei wirklich aufnehmen? Dies startet die Datenverarbeitungspipeline.',
      retract: 'Möchten Sie diese Datei wirklich zurückziehen?',
      delete: 'Möchten Sie diese Datei wirklich dauerhaft löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Aufnahme bestätigen",
      retractTitle: "Zurückziehen bestätigen",
      deleteTitle: "Löschen bestätigen",
      killDocTitle: "Dokumentaufnahme abbrechen",
      killDoc: "Sind Sie sicher, dass Sie die Aufnahmeaufgabe für DIESES Dokument abbrechen möchten? Das System wird versuchen, einen ordnungsgemäßen Rollback durchzuführen.",
      killProcTitle: "GESAMTEN Aufnahmeprozess abbrechen",
      killProc: "WARNUNG: Dies bricht den gesamten Backend-Aufnahmedienst ab und betrifft ALLE derzeit in Bearbeitung befindlichen Dateien. Sind Sie absolut sicher?"
    }
  },
  uploadDialog: {
    title: 'Dateien hochladen',
    dropzone: 'Dateien hierher ziehen & ablegen, oder klicken zum Auswählen',
    allowedTypesLabel: 'Erlaubte Typen:',
    buttonUpload: 'Lade {count} Datei(en) hoch',
    remove: 'Entfernen',
    uploading: 'Hochladen...',
    notifications: {
      dropError: 'Nur Dateien können abgelegt werden. Bitte prüfen Sie, ob Sie eine gültige Datei von Ihrem Computer ziehen.',
      typeNotAllowed: 'Dateityp "{extension}" ist nicht erlaubt.',
      shortcutUnsupported: 'Verknüpfungsdateien (.url) werden nicht unterstützt. Bitte ziehen Sie die eigentliche Datei.',
      duplicate: 'Datei "{fileName}" wurde bereits hinzugefügt.',
      uploadSuccess: '{fileName} erfolgreich hochgeladen',
      uploadFailed: 'Fehler beim Hochladen von {fileName}.'
    }
  }
}